models.service('DocumentV2Model', [
    '$q', 'API', 'ErrorService', 'Utils', 'constants',
    function ($q, API, ErrorService, Utils, Const) {
        function Document(rawDocument) {
            var self = this;
            self.id = rawDocument.id;
            self.type = Utils.toSnakeCase(rawDocument.type);
            self.origType = rawDocument.type;
            self.status = rawDocument.status;
            self.images = [];
            self.twoSidedToggled = false;
            self.subTypes = rawDocument.subtypes.map(function (item) {
                return {
                    id: Utils.toSnakeCase(item.title),
                    title: item.title,
                    origTitle: item.title,
                    images: item.images
                }
            })

            self.subType = _.find(self.subTypes, {origTitle: rawDocument.subtype});
            self.uploaded = rawDocument.uploaded;

            self.uploadStatus = 0;
            self.isUploading = false;
            self.selectedSubType = null;
            self.hasUploaded = self.uploaded.filter(function (item) {
                return item
            }).length > 0;

            this.updateImages = function () {
                if (self.uploaded.filter(function (item) {
                    return item
                }).length === 2) {
                    self.images = [0, 1];
                } else {
                    self.images = self.selectedSubType.images === 0
                        ? [0]
                        : Array(self.selectedSubType.images)
                            .fill(null)
                            .map(function (i, index) {
                                return index
                            })
                }
            }

            if (self.subType) {
                self.selectedSubType = self.subType;
                this.updateImages();
            }

            this.addImage = function () {
                self.images.push(self.images.length);
            }

            this.toggleImage = function () {
                if (self.images.length === 1) {
                    self.images.push(self.images.length);
                } else {
                    self.images = self.images.slice(0, 1)
                }
            }

            this.startUpload = function (file, side) {
                self.isUploading = true;

                const uploadRequest = {
                    name: file.name,
                    size: file.size,
                    type: self.origType,
                    subType: self.selectedSubType.origTitle,
                    image: side,
                    id: self.id
                };

                return API.documentSet(uploadRequest)
                    .then(function (response) {
                        return checkResponse(response, uploadRequest)
                    })
                    .then(function (response) {
                        return response.fileMD5
                    })
                    .catch(function (error) {
                        self.isUploading = false;
                        return $q.reject(error);
                    });
            }
            //
            this.loadChunk = function (fileName, offset, chunk) {
                var reader = new FileReader();
                reader.readAsBinaryString(chunk);

                return $q(function (resolve) {
                    reader.onload = function (_chunk) {
                        reader = null;
                        resolve({
                            fileMD5: fileName,
                            data: _chunk.target.result
                        });
                    };
                })
            }

            this.sendChunk = function (request) {
                return API.documentUpload(request)
                    .then(checkResponse)
                    .then(function (response) {
                        self.uploadStatus = response.percent
                    });
            };

            //
            // public uploadFile(file: any, newFileName: string) {
            //     let chunkSize = 51206;
            //     let chunks = Math.ceil(file.size / chunkSize);
            //     let chunksData = [];
            //
            //     for (let chunk = 0; chunk <= chunks - 1; chunk++) {
            //
            //         let offset = chunk * chunkSize;
            //
            //         let tmp = () => this.loadChunk(newFileName, offset, file.slice(offset, offset + chunkSize))
            //             .then((request: any) => this.sendChunk(request));
            //
            //         chunksData.push(tmp);
            //     }
            //
            //     return chunksData.reduce((promise, fn) => promise.then(fn), Promise.resolve())
            //         .catch((error: any) => {
            //             return Promise.reject(error);
            //         });
            // }
            //
            // public updateStatus() {
            //     this.subType = this.selectedSubType;
            // }
            //

            this.uploadFile = function (file, newFileName) {
                var chunkSize = 51206;
                var chunks = Math.ceil(file.size / chunkSize);
                var chunksData = [];

                function createChunk(offset) {
                    return function () {
                        return self.loadChunk(newFileName, offset, file.slice(offset, offset + chunkSize))
                            .then(self.sendChunk)
                    }
                }

                for (var chunk = 0; chunk <= chunks - 1; chunk++) {
                    chunksData.push(createChunk(chunk * chunkSize));
                }

                return chunksData.reduce(function (promise, fn) {
                    return promise.then(fn)
                }, $q.resolve())
                    .then(function () {
                        self.isUploading = false
                    })
                    .catch(function (error) {
                        self.isUploading = false;
                        return $q.reject(error);
                    });
            };

            this.updateStatus = function() {
                self.subType = self.selectedSubType;
            }

            function checkResponse(data) {
                if (data.status !== 1) {
                    throw new ErrorService({
                        source: 'DocumentV2Model',
                        type: Const.error.type.VALIDATION,
                        code: data.code,
                        severity: 'warning',
                        data: {response: data}
                    });
                }
                return data;
            }


        }
        return Document;
    }
])
